import React from "react";
import styles from "./Stars.module.scss";

const Stars: React.FC<{ count: number }> = ({ count }) => {
  // Используем рейтинг как есть, без дополнительных проверок
  return (
    <div className="flex items-center gap-1">
      {Array(count)
        .fill("")
        .map((_, index) => (
          <div key={index} className={styles.star} />
        ))}
    </div>
  );
};

export default Stars;
